import { Box, Button, TextField, Typography } from "@material-ui/core";
import React from "react";
import { useBankedPayeeForm } from "./hooks/useBankedPayeeForm";
import { Payment } from "./hooks/userPayments";
import { Formik } from "formik";

interface Props {
  payment: Payment;
  closeBankedDialog: () => void;
}

export const BankedPayeeDialog: React.FC<Props> = ({
  payment,
  closeBankedDialog,
}) => {
  const { validationSchema, initialValues, handleFormSubmit } =
    useBankedPayeeForm(payment, closeBankedDialog);
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
    >
      {({ errors, touched, handleChange, handleSubmit, values }) => (
        <>
          <Box display="flex" justifyContent="center">
            <Typography className="base-color" variant="h6">
              Enter Payee Info
            </Typography>
          </Box>
          <Box>
            <Box>
              <Typography className="base-color">Name</Typography>
              <TextField
                onChange={handleChange("name")}
                name="name"
                value={values.name}
                className="referral-fields"
                error={errors.name && touched.name ? true : false}
                label=""
              />
              {errors.name && touched.name && (
                <Typography color="error">{errors.name}</Typography>
              )}
            </Box>
            <Box marginTop="1rem">
              <Box>
                <Typography className="base-color">Account Number</Typography>
                <Typography className="base-color" variant="subtitle2">
                  UK Bank account number (8 digits).
                </Typography>
              </Box>
              <TextField
                onChange={handleChange("accountNumber")}
                name="accountNumber"
                value={values.accountNumber}
                error={
                  errors.accountNumber && touched.accountNumber ? true : false
                }
                className="referral-fields"
                label=""
              />
              {errors.accountNumber && touched.accountNumber && (
                <Typography color="error">{errors.accountNumber}</Typography>
              )}
            </Box>
            <Box marginTop="1rem">
              <Box>
                <Typography className="base-color">Sort Code</Typography>
                <Typography className="base-color" variant="subtitle2">
                  UK Bank sort code (6 digits).
                </Typography>
              </Box>
              <TextField
                onChange={handleChange("sortCode")}
                name="sortCode"
                value={values.sortCode}
                className="referral-fields"
                label=""
                error={errors.sortCode && touched.sortCode ? true : false}
              />
              {errors.sortCode && touched.sortCode && (
                <Typography color="error">{errors.sortCode}</Typography>
              )}
            </Box>
          </Box>
          <Box paddingTop="1.5rem">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={handleSubmit}
            >
              Make Refund
            </Button>
          </Box>
        </>
      )}
    </Formik>
  );
};
